/* ==========================================================================
   Scroll animations — shared across all sections.
   Reveals any [data-animate] element when it enters the viewport.
   Safe to include on every section; only initializes once per page.
   ========================================================================== */
(function () {
  function setup() {
    var elements = document.querySelectorAll('[data-animate]:not([data-animate-bound])');
    if (!elements.length) return;

    elements.forEach(function (el) {
      el.setAttribute('data-animate-bound', 'true');

      var delay = el.getAttribute('data-animate-delay');
      if (delay) {
        el.style.setProperty('--animate-delay', delay + 'ms');
      }
    });

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -8% 0px'
    });

    elements.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // Re-scan when a section is added/re-rendered in the theme editor
  document.addEventListener('shopify:section:load', setup);
})();